import React from "react";
import { SavedFilters, SelectedFiltersContext } from "./SelectedFiltersContext";

interface Props {
  children: React.ReactNode;
}

export const SelectedFiltersProvider = (props: Props) => {
  const selectedFiltersRef = React.useRef<SavedFilters | null>(null);

  const contextValue = React.useMemo(
    () => ({
      selectedFiltersRef,
    }),
    [selectedFiltersRef]
  );

  return (
    <SelectedFiltersContext.Provider value={contextValue}>
      {props.children}
    </SelectedFiltersContext.Provider>
  );
};
